require('dotenv').config();
module.exports = {
    api_key : process.env.REACT_APP_GOOGLE_API_KEY
}